import { DefaultButton, IPanelProps, IRenderFunction, Panel, PanelType, PrimaryButton, Stack, TextField, Toggle } from "@fluentui/react";
import CESDropdown from "components/controls/CESDropdown";
import SectionItem, { ESectionItemVariant } from "components/controls/SectionItem/Index";
import { panelButtonsStyles } from "global/Application";
import { useApplication } from "global/Application/Context";
import { useEffect, useState } from "react";
import * as FAM from "../../model/FlexibleAttributeModel";

interface IProps {
    isOpen?: boolean;
    onCancel?: () => void;
    onDismiss?: () => void;
    department?: FAM.IDepartment
    onConfirm?: (department: FAM.IDepartment) => void;
}

const GroupStructureDepartmentEditor: React.FunctionComponent<IProps> = (props) => {

    const application = useApplication();

    const [department, setDepartment] = useState<FAM.IDepartment | null>(
        props.department
            ? props.department
            : null
    );

    useEffect(() => {
        if (props.department)
            setDepartment(props.department);
    }, [props.department])


    const onRenderUnknown = () => {
        return <div>Unknown View.</div>
    }

    const onRenderBody: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        if (!department)
            return onRenderUnknown();

        return <SectionItem title="Properties" variant={ESectionItemVariant.Drawer}>
            <Stack tokens={{ childrenGap: '15px' }}>
                <CESDropdown
                    value={department.cesNumberRef ? { id: department.cesNumberRef.id, cesNumber: department.cesNumberRef.name, deactivated: false } : undefined}
                    onChange={(option) => {
                        setDepartment(t => { return { ...t!, cesNumberRef: { id: option.id, name: option.cesNumber } } });
                    }}
                />
                <TextField
                    label="Department"
                    value={department.name ?? ''}
                    onChange={(event, newValue) => {
                        setDepartment(t => { return { ...t!, name: newValue ?? null } });
                    }}
                />
                <TextField
                    label="Description"
                    value={department.description ?? ''}
                    onChange={(event, newValue) => {
                        setDepartment(t => { return { ...t!, description: newValue ?? null } });
                    }}
                />

                <Toggle
                    label={"Deactivate"}
                    disabled={!application.ChangeTypePermissions.canDeactivateGroupStructure}
                    checked={department.deactivated ?? false}
                    onChange={(_, checked) => {
                        setDepartment(t => { return { ...t!, deactivated: checked ?? false }; });
                    }}
                />
            </Stack>
        </SectionItem>
    }

    const onRenderFooter: IRenderFunction<IPanelProps> = (footerProps, defaultRender) => {
        if (!department)
            return onRenderUnknown();

        return <>
            <PrimaryButton text='Continue'
                styles={panelButtonsStyles}
                onClick={async () => {
                    props.onConfirm?.(department);
                    props.onDismiss?.();
                }}
            />

            <DefaultButton text='Cancel'
                styles={panelButtonsStyles}
                onClick={async () => {
                    props.onCancel?.();
                }}
            />
        </>
    }

    return <Panel
        isOpen={props.isOpen}
        onDismiss={props.onCancel}
        type={PanelType.medium}
        layerProps={{ eventBubblingEnabled: true }}
        isLightDismiss
        headerText="Manage | Group Structure"
        onRenderFooterContent={onRenderFooter}
        isFooterAtBottom={true}
    >
        {onRenderBody()}
    </Panel>
}

export default GroupStructureDepartmentEditor;